module.exports = __webpack_public_path__ + "img/summary_5.a3644783.png";